import { type ReactNode } from "react";

import cx from "@hsl/core/utils/cx";

const COLORS = ["gray", "blue", "green", "red"] as const;

export interface Props {
    icon: ReactNode;
    color?: (typeof COLORS)[number];
    onClick?(): void;
}

const CircularButton = ({ icon, color, onClick }: Props) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cx(
                "rounded-full p-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ",
                color ? "text-white shadow-sm" : "text-gray-800",
                {
                    "bg-gray-600 hover:bg-gray-500 focus-visible:outline-gray-600":
                        color === "gray",
                    "bg-blue-600 hover:bg-blue-500 focus-visible:outline-blue-600":
                        color === "blue",
                    "bg-green-600 hover:bg-green-500 focus-visible:outline-green-600":
                        color === "green",
                    "bg-red-600 hover:bg-red-500 focus-visible:outline-red-600":
                        color === "red",
                },
            )}
        >
            {icon}
        </button>
    );
};

export default CircularButton;
